import { z } from 'zod';

/**
 * ObraFit Module 1 · Photo albums.
 *
 * Albums group existing photos. Photo comments piggy-back on the
 * existing `comments` infrastructure (entityType='photo'). This schema
 * only covers the album metadata + photo→album assignment.
 */

export const photoAlbumSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  coverPhotoId: z.string().nullable(),
  coverPhotoUrl: z.string().nullable(),
  sortOrder: z.number().int(),
  photoCount: z.number().int(),
  createdBy: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type PhotoAlbum = z.infer<typeof photoAlbumSchema>;

export const createPhotoAlbumRequestSchema = z.object({
  projectId: z.string().min(1),
  name: z.string().trim().min(1).max(120),
  description: z.string().trim().max(400).nullable().optional(),
});
export type CreatePhotoAlbumRequest = z.infer<typeof createPhotoAlbumRequestSchema>;

export const updatePhotoAlbumRequestSchema = z.object({
  name: z.string().trim().min(1).max(120).optional(),
  description: z.string().trim().max(400).nullable().optional(),
  coverPhotoId: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
});
export type UpdatePhotoAlbumRequest = z.infer<typeof updatePhotoAlbumRequestSchema>;

export const assignPhotoToAlbumRequestSchema = z.object({
  albumId: z.string().nullable(),
});
export type AssignPhotoToAlbumRequest = z.infer<typeof assignPhotoToAlbumRequestSchema>;
